export const COUNTRIES = [
    { value: 'Afganistan', label: 'Afganistan' },
    { value: 'Albánsko', label: 'Albánsko' },
    { value: 'Alžírsko', label: 'Alžírsko' },
    { value: 'Andorra', label: 'Andorra' },
    { value: 'Angola', label: 'Angola' },
    { value: 'Antigua a Barbuda', label: 'Antigua a Barbuda' },
    { value: 'Argentína', label: 'Argentína' },
    { value: 'Arménsko', label: 'Arménsko' },
    { value: 'Austrália', label: 'Austrália' },
    { value: 'Rakúsko', label: 'Rakúsko' },
    { value: 'Azerbajdžan', label: 'Azerbajdžan' },
    { value: 'Bahamy', label: 'Bahamy' },
    { value: 'Bahrajn', label: 'Bahrajn' },
    { value: 'Bangladéš', label: 'Bangladéš' },
    { value: 'Barbados', label: 'Barbados' },
    { value: 'Bielorusko', label: 'Bielorusko' },
    { value: 'Belgicko', label: 'Belgicko' },
    { value: 'Belize', label: 'Belize' },
    { value: 'Benin', label: 'Benin' },
    { value: 'Bhután', label: 'Bhután' },
    { value: 'Bolívia', label: 'Bolívia' },
    { value: 'Bosna a Hercegovina', label: 'Bosna a Hercegovina' },
    { value: 'Botswana', label: 'Botswana' },
    { value: 'Brazília', label: 'Brazília' },
    { value: 'Brunej', label: 'Brunej' },
    { value: 'Bulharsko', label: 'Bulharsko' },
    { value: 'Burkina', label: 'Burkina' },
    { value: 'Burundi', label: 'Burundi' },
    { value: 'Kapverdy', label: 'Kapverdy' },
    { value: 'Kambodža', label: 'Kambodža' },
    { value: 'Kamerun', label: 'Kamerun' },
    { value: 'Kanada', label: 'Kanada' },
    { value: 'Stredoafrická republika', label: 'Stredoafrická republika' },
    { value: 'Čad', label: 'Čad' },
    { value: 'Čile', label: 'Čile' },
    { value: 'Čína', label: 'Čína' },
    { value: 'Kolumbia', label: 'Kolumbia' },
    { value: 'Komory', label: 'Komory' },
    { value: 'Kongo', label: 'Kongo' },
    { value: 'Konžská demokratická republika', label: 'Konžská demokratická republika' },
    { value: 'Kostarika', label: 'Kostarika' },
    { value: 'Chorvátsko', label: 'Chorvátsko' },
    { value: 'Kuba', label: 'Kuba' },
    { value: 'Cyprus', label: 'Cyprus' },
    { value: 'Česko', label: 'Česko' },
    { value: 'Dánsko', label: 'Dánsko' },
    { value: 'Džibutsko', label: 'Džibutsko' },
    { value: 'Dominika', label: 'Dominika' },
    { value: 'Dominikánska republika', label: 'Dominikánska republika' },
    { value: 'Ekvádor', label: 'Ekvádor' },
    { value: 'Egypt', label: 'Egypt' },
    { value: 'Salvádor', label: 'Salvádor' },
    { value: 'Rovníková Guinea', label: 'Rovníková Guinea' },
    { value: 'Eritrea', label: 'Eritrea' },
    { value: 'Estónsko', label: 'Estónsko' },
    { value: 'Eswatini', label: 'Eswatini' },
    { value: 'Etiópia', label: 'Etiópia' },
    { value: 'Fidži', label: 'Fidži' },
    { value: 'Fínsko', label: 'Fínsko' },
    { value: 'Francúzsko', label: 'Francúzsko' },
    { value: 'Gabon', label: 'Gabon' },
    { value: 'Gambia', label: 'Gambia' },
    { value: 'Gruzínsko', label: 'Gruzínsko' },
    { value: 'Nemecko', label: 'Nemecko' },
    { value: 'Ghana', label: 'Ghana' },
    { value: 'Grécko', label: 'Grécko' },
    { value: 'Grenada', label: 'Grenada' },
    { value: 'Guatemala', label: 'Guatemala' },
    { value: 'Guinea', label: 'Guinea' },
    { value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
    { value: 'Guyana', label: 'Guyana' },
    { value: 'Haiti', label: 'Haiti' },
    { value: 'Honduras', label: 'Honduras' },
    { value: 'Maďarsko', label: 'Maďarsko' },
    { value: 'Island', label: 'Island' },
    { value: 'India', label: 'India' },
    { value: 'Indonézia', label: 'Indonézia' },
    { value: 'Irán', label: 'Irán' },
    { value: 'Irak', label: 'Irak' },
    { value: 'Írsko', label: 'Írsko' },
    { value: 'Izrael', label: 'Izrael' },
    { value: 'Taliansko', label: 'Taliansko' },
    { value: 'Jamajka', label: 'Jamajka' },
    { value: 'Japonsko', label: 'Japonsko' },
    { value: 'Jordánsko', label: 'Jordánsko' },
    { value: 'Kazachstan', label: 'Kazachstan' },
    { value: 'Keňa', label: 'Keňa' },
    { value: 'Kiribati', label: 'Kiribati' },
    { value: 'Kuvajt', label: 'Kuvajt' },
    { value: 'Kirgizsko', label: 'Kirgizsko' },
    { value: 'Laos', label: 'Laos' },
    { value: 'Lotyšsko', label: 'Lotyšsko' },
    { value: 'Libanon', label: 'Libanon' },
    { value: 'Lesotho', label: 'Lesotho' },
    { value: 'Libéria', label: 'Libéria' },
    { value: 'Líbya', label: 'Líbya' },
    { value: 'Lichtenštajnsko', label: 'Lichtenštajnsko' },
    { value: 'Litva', label: 'Litva' },
    { value: 'Luxembursko', label: 'Luxembursko' },
    { value: 'Madagaskar', label: 'Madagaskar' },
    { value: 'Malawi', label: 'Malawi' },
    { value: 'Malajzia', label: 'Malajzia' },
    { value: 'Maldivy', label: 'Maldivy' },
    { value: 'Mali', label: 'Mali' },
    { value: 'Malta', label: 'Malta' },
    { value: 'Marshallove ostrovy', label: 'Marshallove ostrovy' },
    { value: 'Mauritánia', label: 'Mauritánia' },
    { value: 'Maurícius', label: 'Maurícius' },
    { value: 'Mexiko', label: 'Mexiko' },
    { value: 'Mikronézia', label: 'Mikronézia' },
    { value: 'Moldavsko', label: 'Moldavsko' },
    { value: 'Monako', label: 'Monako' },
    { value: 'Mongolsko', label: 'Mongolsko' },
    { value: 'Čierna Hora', label: 'Čierna Hora' },
    { value: 'Maroko', label: 'Maroko' },
    { value: 'Mozambik', label: 'Mozambik' },
    { value: 'Mjanmarsko', label: 'Mjanmarsko' },
    { value: 'Namíbia', label: 'Namíbia' },
    { value: 'Nauru', label: 'Nauru' },
    { value: 'Nepál', label: 'Nepál' },
    { value: 'Holandsko', label: 'Holandsko' },
    { value: 'Nový Zéland', label: 'Nový Zéland' },
    { value: 'Nikaragua', label: 'Nikaragua' },
    { value: 'Niger', label: 'Niger' },
    { value: 'Nigéria', label: 'Nigéria' },
    { value: 'Kórejská ľudovodemokratická republika', label: 'Kórejská ľudovodemokratická republika' },
    { value: 'Severné Macedónsko', label: 'Severné Macedónsko' },
    { value: 'Nórsko', label: 'Nórsko' },
    { value: 'Omán', label: 'Omán' },
    { value: 'Pakistan', label: 'Pakistan' },
    { value: 'Palau', label: 'Palau' },
    { value: 'Panama', label: 'Panama' },
    { value: 'Papua Nová-Guinea', label: 'Papua Nová-Guinea' },
    { value: 'Paraguaj', label: 'Paraguaj' },
    { value: 'Peru', label: 'Peru' },
    { value: 'Filipíny', label: 'Filipíny' },
    { value: 'Pobrežie Slonoviny', label: 'Pobrežie Slonoviny' },
    { value: 'Poľsko', label: 'Poľsko' },
    { value: 'Portugalsko', label: 'Portugalsko' },
    { value: 'Katar', label: 'Katar' },
    { value: 'Rumunsko', label: 'Rumunsko' },
    { value: 'Rusko', label: 'Rusko' },
    { value: 'Rwanda', label: 'Rwanda' },
    { value: 'Svätý Krištof a Nevis', label: 'Svätý Krištof a Nevis' },
    { value: 'Svätá Lucia', label: 'Svätá Lucia' },
    { value: 'Svätý Vincent a Grenadíny', label: 'Svätý Vincent a Grenadíny' },
    { value: 'Samoa', label: 'Samoa' },
    { value: 'San Maríno', label: 'San Maríno' },
    { value: 'Svätý Tomáš a Princov ostrov', label: 'Svätý Tomáš a Princov ostrov' },
    { value: 'Saudská Arábia', label: 'Saudská Arábia' },
    { value: 'Senegal', label: 'Senegal' },
    { value: 'Srbsko', label: 'Srbsko' },
    { value: 'Seychely', label: 'Seychely' },
    { value: 'Sierra Leone', label: 'Sierra Leone' },
    { value: 'Singapur', label: 'Singapur' },
    { value: 'Slovensko', label: 'Slovensko' },
    { value: 'Slovinsko', label: 'Slovinsko' },
    { value: 'Šalamúnove ostrovy', label: 'Šalamúnove ostrovy' },
    { value: 'Somálsko', label: 'Somálsko' },
    { value: 'Južná Afrika', label: 'Južná Afrika' },
    { value: 'Kórejská republika', label: 'Kórejská republika' },
    { value: 'Južný Sudán', label: 'Južný Sudán' },
    { value: 'Španielsko', label: 'Španielsko' },
    { value: 'Srí Lanka', label: 'Srí Lanka' },
    { value: 'Sudán', label: 'Sudán' },
    { value: 'Surinam', label: 'Surinam' },
    { value: 'Švédsko', label: 'Švédsko' },
    { value: 'Švajčiarsko', label: 'Švajčiarsko' },
    { value: 'Sýria', label: 'Sýria' },
    { value: 'Taiwan', label: 'Taiwan' },
    { value: 'Tadžikistan', label: 'Tadžikistan' },
    { value: 'Tanzánia', label: 'Tanzánia' },
    { value: 'Thajsko', label: 'Thajsko' },
    { value: 'Východný Timor', label: 'Východný Timor' },
    { value: 'Togo', label: 'Togo' },
    { value: 'Tonga', label: 'Tonga' },
    { value: 'Trinidad a Tobago', label: 'Trinidad a Tobago' },
    { value: 'Tunisko', label: 'Tunisko' },
    { value: 'Turecko', label: 'Turecko' },
    { value: 'Turkménsko', label: 'Turkménsko' },
    { value: 'Tuvalu', label: 'Tuvalu' },
    { value: 'Uganda', label: 'Uganda' },
    { value: 'Ukrajina', label: 'Ukrajina' },
    { value: 'Spojené arabské emiráty', label: 'Spojené arabské emiráty' },
    { value: 'Spojené kráľovstvo', label: 'Spojené kráľovstvo' },
    { value: 'Spojené štáty americké', label: 'Spojené štáty americké' },
    { value: 'Uruguaj', label: 'Uruguaj' },
    { value: 'Uzbekistan', label: 'Uzbekistan' },
    { value: 'Vanuatu', label: 'Vanuatu' },
    { value: 'Vatikán', label: 'Vatikán' },
    { value: 'Venezuela', label: 'Venezuela' },
    { value: 'Vietnam', label: 'Vietnam' },
    { value: 'Jemen', label: 'Jemen' },
    { value: 'Zambia', label: 'Zambia' },
    { value: 'Zimbabwe', label: 'Zimbabwe' },
];
